import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import ProductGroupCreate from "modules/productGroups/ProductGroupCreate";

export default function ProductGroupCreatePage() {
  return (
    <DashboardPage>
      <MDBox mb={6}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MDTypography variant="h4" fontWeight="medium">
              Create Product Group
            </MDTypography>
          </Grid>
        </Grid>
      </MDBox>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <ProductGroupCreate />
        </Grid>
      </Grid>
    </DashboardPage>
  );
}
